<template>
    <div>
        <home></home>
        <Config></Config>
    </div>
</template>

<script>
import Home from "@/views/home";
import Config from "@/components/Config";

export default {
    name: "config",
    components: {Home, Config}
}
</script>

<style scoped>

</style>
